import { NextContentfulImage } from "@components/Image";
import SwiperNavigation from "@components/Swiper/SwiperNavigation";
import { ImageWrapperType } from "@customTypes/imageWrapper";
import { useDevice } from "@utilities/react/get-device/get-device";
import clsx from "clsx";
import { useState } from "react";
import { Pagination } from "swiper/modules";
import { Swiper as SwiperCarousel, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/pagination";
import { Swiper as SwiperProps } from "swiper/types";

import styles from "./ImageCarousel.module.scss";

export interface ImageCarouselProps {
  label?: string;
  title: string;
  description: string;
  carouselImages?: ImageWrapperType[];
}

const ImageCarousel = ({ content }: { content: ImageCarouselProps }) => {
  const { label, title, description, carouselImages } = content;
  const [slide, setSlide] = useState(1);
  const [swiper, setSwiper] = useState<SwiperProps>();
  const device = useDevice();

  const variation = device === "mobile" ? "square" : "fraction";

  return (
    <div className={styles["image-carousel"]}>
      <div className={styles["block-container"]}>
        <div className={styles["text-content"]}>
          {label && <p className={clsx("label", styles.label)}>{label}</p>}
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>

      {carouselImages && carouselImages.length > 0 && (
        <div className={clsx("wrapper", styles.wrapper)}>
          {swiper && (
            <>
              <SwiperNavigation
                className={styles["image-carousel-prev"]}
                swiper={swiper}
                direction="prev"
                perPage={1}
                variation={variation}
                hideOnEdge={true}
              />
              <SwiperNavigation
                className={styles["image-carousel-next"]}
                swiper={swiper}
                direction="next"
                perPage={1}
                variation={variation}
                hideOnEdge={true}
              />
            </>
          )}

          <SwiperCarousel
            allowTouchMove={false}
            spaceBetween={10}
            slidesPerView={"auto"}
            centeredSlides={true}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            onSlideChange={({ activeIndex }) => {
              setSlide(activeIndex + 1);
            }}
            onSwiper={(swiper) => {
              setSwiper(swiper);
            }}
          >
            {carouselImages.map((carouselImage, index) => (
              <SwiperSlide key={`${carouselImage.fields.url}${index}`}>
                <NextContentfulImage
                  alt={carouselImage.fields.altText}
                  src={carouselImage.fields.url}
                  width={carouselImage.fields.width}
                  height={carouselImage.fields.height}
                />
              </SwiperSlide>
            ))}
          </SwiperCarousel>
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
